module.exports = __webpack_public_path__ + "img/Mosaic.211b9ac.svg";